import { render, staticRenderFns } from "./MultipleChoiceCheckbox.vue?vue&type=template&id=1939e127"
import script from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceCheckbox.vue?vue&type=style&index=0&id=1939e127&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports